// ClaimCapCard's read (finance-real, the user 2026-10-22): Setup's ceiling on every job's claims.
import type { UseQueryResult } from "@tanstack/react-query";
import { useClaimSettings } from "../../hooks/useJobClaims";
import type { ClaimSettings } from "../../types";

export interface ClaimCapCardModel {
  settings: UseQueryResult<ClaimSettings>;
}

export function useClaimCapCard(): ClaimCapCardModel {
  return { settings: useClaimSettings() };
}
